import React from 'react';
import './Sleeve.scss';
import { IMG } from '../../../Commons/Functions';

function SleeveComponent({ showReflection = true, children, tilt = { x: 0, y: 0 }, sleeveData }) {
    if (!sleeveData) { return (children) }

    return (
        <div className={`sleeve-wrapper`}>
            <SleeveBackground sleeveData={sleeveData} />
            <div className="card-content position-abolute top-0 start-0 w-100 h-100">
                {children}
            </div>
            <SleeveBack sleeveData={sleeveData} />
            <SleeveReflection showReflection={showReflection} tiltX={tilt.x} tiltY={tilt.y} visible={"front"} />
            <SleeveReflection showReflection={showReflection} tiltX={tilt.x} tiltY={tilt.y} visible={"back"} glossyness={sleeveData.glossyness} />
        </div>
    );
};

const areEqual = (prevProps, nextProps) => {
    const prevTilt = prevProps.tilt || { x: 0, y: 0 };
    const nextTilt = nextProps.tilt || { x: 0, y: 0 };

    return (
        prevProps.showReflection === nextProps.showReflection &&
        prevTilt.x === nextTilt.x &&
        prevTilt.y === nextTilt.y &&
        prevProps.children === nextProps.children &&
        JSON.stringify(prevProps.sleeveData) === JSON.stringify(nextProps.sleeveData)
    );
};

export const Sleeve = React.memo(SleeveComponent, areEqual);
export default Sleeve;

function SleeveReflection({ showReflection, tiltX = 0, tiltY = 0, visible, glossyness = 0.4 }) {
    //if (!showReflection) { return } A testeer niveau perf par rapport à opacity = 0, semblerait que ca soit mieux le return
    const angle = Math.atan2(tiltY, tiltX) * (180 / Math.PI);
    const tiltStrength = Math.sqrt(tiltX ** 2 + tiltY ** 2); // de 0 à ~21
    const intensity = Math.min(Math.max((tiltStrength - 8) / 10, 0), 1); // commence à apparaître au-delà de tilt ≈ 5

    return (
        <div
            className={`sleeve-reflection`}
            style={{
                transform: `rotate(${angle}deg)`,
                opacity: showReflection ? glossyness * intensity : 0,
            }}
        />
    );
}

function SleeveBackground({ sleeveData }) {
    return (
        <div className={`sleeve-background visible-front`} style={{ backgroundColor: sleeveData.color }}>
        </div>
    );
}

const SleeveBack = React.memo(function SleeveBack({ sleeveData }) {
    return (
        <div className={`sleeve-back visible-back ${sleeveData.isGrainy ? 'grainy' : ''}`}>
            {sleeveData.imageUrl ? (
                <IMG
                    className="w-100 h-100 position-absolute top-0 start-0"
                    src={sleeveData.imageUrl}
                />
            ) : (
                <div
                    className="w-100 h-100 position-absolute top-0 start-0"
                    style={{ backgroundColor: sleeveData.color }}
                />
            )}
            {sleeveData.isGrainy && <div className="grain-overlay" />}
        </div>
    );
}, areEqual);